import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f47e759"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "data shop-data" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "设备运行情况")
], -1))
const _hoisted_4 = { class: "data-list" }
const _hoisted_5 = { class: "success" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "运行中", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "已关闭", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", null, "未部署", -1))
const _hoisted_9 = { class: "shop-item-head" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-dianpu" }, null, -1))
const _hoisted_11 = { class: "shop-item-info" }
const _hoisted_12 = { class: "box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "边缘机IP地址：", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "边缘机序列号：", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "主机标识：", -1))

import { ref, onActivated } from 'vue'
import { useRoute } from 'vue-router'

import { getShops } from '@/api/shop'
import { IShop } from '@/utils/interface'
import ComHeader from '@/components/ComHeader/index.vue'
import SearchWrapper from '@/components/Search/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const working = ref(0)
const closed = ref(0)
const arrange = ref(0)
const list = ref<any[]>([])
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const curPage = ref(1)
const curSize = ref(20)
const isOpen = ref(false)
const margin = ref(0)
const header = ref<null | HTMLElement>(null)
const serverStatus = ['运行中', '未部署', '已关闭']

const onLoad = () => {
  setTimeout(() => {
    if (refreshing.value) {
      list.value = []
      curPage.value = 1
      refreshing.value = false
    }

    getShops({
      page: curPage.value,
      size: curSize.value
    }).then((res: any) => {
      if (curPage.value === 1) {
        list.value = res.storeList
      } else {
        list.value = list.value.concat(res.storeList)
      }
      loading.value = false

      // if (list.value.length >= res.row) {
      //   finished.value = true
      // } else {
      //   curPage.value += 1
      // }
      finished.value = true
      working.value = res.start
      arrange.value = res.unDeploy
      closed.value = res.stop
      // handleStatus()
    })
  }, 500)
}

const onRefresh = () => {
  // 清空列表数据
  finished.value = false

  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  onLoad()
}

const goSearch = () => {
  margin.value = header.value?.offsetHeight || 0
  isOpen.value = !isOpen.value
}

const handleData = (data: any) => {
  isOpen.value = false
  if (!data) {
    refreshing.value = true
    onRefresh()
    return
  }
  list.value = data.storeList
  finished.value = true
  working.value = data.start
  arrange.value = data.stop
  closed.value = data.unDeploy
  // handleStatus()
}
// const handleStatus = () => {
//   working.value = 0
//   arrange.value = 0
//   closed.value = 0
//   list.value.forEach((item: IShop) => {
//     if (item.serverStatus === 1) {
//       working.value += 1
//     } else if (item.serverStatus === 2) {
//       arrange.value += 1
//     } else {
//       closed.value += 1
//     }
//   })
// }

const isInit = ref(true)
const route = useRoute()
onActivated(() => {
  if (!route.meta.isBack && !isInit.value) {
    isOpen.value = false
    onRefresh()
  }
  isInit.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "header",
      ref: header
    }, [
      _createVNode(ComHeader, {
        height: 16,
        title: "门店管理"
      }, {
        icon: _withCtx(() => [
          _createElementVNode("i", {
            onClick: goSearch,
            class: _normalizeClass([
              'iconfont',
              isOpen.value ? 'icon-quxiao' : 'icon-chakanxiangqing'
            ])
          }, null, 2)
        ]),
        _: 1
      })
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_5, _toDisplayString(working.value), 1),
          _hoisted_6
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", null, _toDisplayString(closed.value), 1),
          _hoisted_7
        ]),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", null, _toDisplayString(arrange.value), 1),
          _hoisted_8
        ])
      ])
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          class: "shops",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                to: `/shop/${item.storeNo}`,
                class: "shop-item",
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", null, _toDisplayString(item.storeName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, [
                      _createElementVNode("span", null, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(item.ip), 1)
                      ]),
                      _createElementVNode("span", null, [
                        _hoisted_14,
                        _createTextVNode(_toDisplayString(item.machineCode), 1)
                      ])
                    ]),
                    _createElementVNode("p", null, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(item.machineKey), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (isOpen.value)
      ? (_openBlock(), _createBlock(SearchWrapper, {
          key: 0,
          margin: margin.value,
          onHandle: handleData
        }, null, 8, ["margin"]))
      : _createCommentVNode("", true)
  ]))
}
}

})